import { useSelectedPrimaryImage } from '~/hooks/image/useSelectedImages';
import { APIType } from '~/backend/types';
import { useRegistration } from '~/hooks/workflows/backend/tasks/useRegistration';
import { useBackendModels } from '~/hooks/workflows/backend/useBackend';
import { PredictionModel } from '~/utils/transforms/predictionModelsDataTransforms';
import ContourPropagation from './ContourPropagation';
import { useLoadedTargetImages } from './ContourPropagation/useLoadedTargetImages';
import { useTargetImageChoice } from './ContourPropagation/useTargetImageChoice';

export default function AdaptBackendWorkflow() {
    const { startProcessing, isSubmitting } = useRegistration();
    const primaryImage = useSelectedPrimaryImage();
    const {
        data: availableModels = [],
        isLoading: isLoadingModels,
        error,
    } = useBackendModels(APIType.REGISTRATION);

    const targetImages = useLoadedTargetImages();

    const [registrationTargetImage, setRegistrationTargetImage] =
        useTargetImageChoice(targetImages);

    const onSubmit = (
        selectedModel: PredictionModel,
        selectedStructures: string[],
        selectedCustomization?: string
    ) => {
        startProcessing({
            selectedModel,
            targetImageSeriesUid: registrationTargetImage?.seriesId,
            selectedStructures,
            customizationName: selectedCustomization,
        });
    };

    return (
        <ContourPropagation
            availableModels={availableModels}
            sourceModality={primaryImage?.seriesMetadata.modality}
            onSubmit={onSubmit}
            isLoadingModels={isLoadingModels}
            targetImages={targetImages}
            selectedTargetImage={registrationTargetImage}
            setSelectedTargetImage={setRegistrationTargetImage}
            isSubmitting={isSubmitting}
            error={error}
            showPseudonymization={true}
        />
    );
}
